import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';
import { PaquetesService } from 'src/app/services/paquetes.service';

@Component({
  selector: 'app-placas',
  templateUrl: './placas.component.html',
  styleUrls: ['./placas.component.scss']
})
export class PlacasComponent implements OnInit {
  enviroment = environment.BASE_URL;
  dtOptions: DataTables.Settings = {
    dom: 'tip',                      // Estructura de la tabla     --> https://datatables.net/reference/option/dom
    lengthMenu: [],                      // Menú de tamaños de página   --> https://datatables.net/reference/option/lengthMenu
    order: [1, 'desc'],
    paging: true,
    pagingType: 'simple_numbers',
    pageLength: 10,
  };
  dtTrigger: Subject<any> = new Subject();

  respuestaPlacas:any;
  placas = []

  p: number = 1;

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  respuestaPaquetes:any;

  datosItem;
  itemId;
  data;
  imagenActual;

  formulario;
  formularioEdit;

  tiposPaquete:any;

  constructor(private _getPlacas: ClientesService, private _agregarPlaca: CatalogosService, private _editarPlaca:CatalogosService,
    private _updatePlaca: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService, 
    private _getPaquetes:PaquetesService) { }

  ngOnInit(): void {
    this.getPlacas();
    this.getTiposPaquete();

    this.formulario = {
      'nombre':'',
      imagen: '',
      tipo_paquete: '',
    }

    this.formularioEdit = {
      'nombre':'',
      imagen: '',
      tipo_paquete: '',
    }

  }

  getPlacas(){
    this._getPlacas.getPlacas().subscribe(
      data => {
        this.respuestaPlacas = data;
        if(this.respuestaPlacas.success){
          this.placas = this.respuestaPlacas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getTiposPaquete(){
    this._getPaquetes.getTiposPaquete().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.tiposPaquete = this.respuestaPaquetes.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }


  agregarPlaca(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('tipo_paquete', this.formulario.tipo_paquete);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregarPlaca.agregarPlaca(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getPlacas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  editarPlaca(placa){
    this.data = {
      'placa':placa,
    }
    this._editarPlaca.editarPlaca(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.formularioEdit.tipo_paquete = this.datosItem.tipo_paquete;
          this.imagenActual = this.datosItem.imagen;
          this.itemId = placa;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updatePlaca(placa){

    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('tipo_paquete', this.formularioEdit.tipo_paquete);
    formData.append('placa', placa);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updatePlaca.updatePlaca(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getPlacas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
